module.exports = __webpack_public_path__ + "img/civil.e6693f07.svg";